<template>

    <nav class="topnav" v-if="authenticated">
        <ul>
            <li>
                <router-link to="/"><i class="fa fa-home"></i></router-link>
            </li>
        </ul>
        <router-link to="/" class="navbar-brand"><img class="logo" alt="Lewis Rice" src="../assets/images/lewis-rice-logo-white.svg"></router-link>
        <ul class="tools">
            <li>
                <router-link to="/user-settings"><i class="fa fa-gear"></i></router-link>
            </li>
            <li>
                <router-link to="/logout"><i class="fa fa-sign-out"></i></router-link>
            </li>
        </ul>
    </nav>

</template>



<script>

    export default {

        name: 'navbar-alt',

        props: ['authenticated']

    }

</script>



<style lang="scss" scoped>

    @import "../variables";

    .navbar-brand {
        text-align: center;
        .logo {
            height: 1em;
        }
    }

    .topnav {
        z-index: 9999;
        background-color: $brand-blue-dark;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        display:flex;
        flex-direction: row;
        padding: 0 10px;

        &>* {
            flex-grow:1;
        }

        ul,
        .tools {
            flex-grow:0;
            text-align: left;
            padding-left: 0;
            margin: 0;
            color: #fff;

            li {
                display: inline-block;

                a {
                    color: #fff;
                    font-size:1.5rem;
                    padding: 8px;
                    display: block;
                }
            }
        }

        .tools {
            text-align: right;
        }
    }

</style>



// WEBPACK FOOTER //
// NavbarAlt.vue?541b7b40